import React from "react";
import { Box, CircularProgress, Grid } from "@mui/material";
import styled from "styled-components";
import Flex from "src/components/flex";

const H1 = styled.h1`
    font-size: 22px;
    font-weight: 500;
    color: ${({ theme }) => theme.palette.primary.main};
`;

const Span = styled.span`
    font-size: 16px;
    font-weight: 300;
    opacity: 0.35;
    color: ${({ theme }) => theme.palette.text.secondary};
`;
const EmailValidation = () => {
    return (
        <Box mt={5}>
            <Grid
                container
                spacing={3}
                direction="column"
                alignItems="center"
                justifyContent="center"
            >
                <Grid item style={{ textAlign: "center" }}>
                    <H1>Your email is being verified</H1>
                    <Span>You will be redirected momentarily</Span>
                </Grid>
                <Grid item style={{ marginTop: "40px" }}>
                    <Flex justifyContent="center">
                        <CircularProgress size={50} />
                    </Flex>
                </Grid>
            </Grid>
        </Box>
    );
};

export default EmailValidation;
